import React from "react";

// dineroDisabledMask siempre imprime "$" y no sabe de moneda, asi que un importe en USD se lee
// igual que uno en pesos. Este span va pegado a la cifra para decir en que moneda esta.
//
// Se muestra siempre, tambien en MXN: es lo que hace el catalogo de Insumos
// (Insumos.js, columna Costo), que es la pantalla hermana. Si algun dia se prefiere ocultarla
// en pesos, el cambio es un if aqui y aplica a todos los consumidores de golpe.
const EtiquetaMoneda = ({ moneda, style }) => (
  <span
    style={{
      fontSize: 11,
      color: "#9ca3af",
      fontWeight: 500,
      marginLeft: 4,
      ...style,
    }}
  >
    {moneda || "MXN"}
  </span>
);

export default EtiquetaMoneda;
